import { createContext, PropsWithChildren, useContext, useState } from 'react';
import LoaderAnimation from '../components/ui/LoaderAnimation';

type PageLoaderType = {
  isBusy: boolean;
  setBusy: (value: boolean) => void;
};

const PageLoaderContext = createContext<PageLoaderType | null>(null);

export const PageLoaderProvider = ({ children }: PropsWithChildren) => {
  const [isBusy, setIsBusy] = useState<boolean>(false);
  const setBusy = (value: boolean) => setIsBusy(value);
  return (
    <PageLoaderContext.Provider value={{ isBusy, setBusy }}>
      {isBusy && <PageLoader />}
      {children}
    </PageLoaderContext.Provider>
  );
};

export const usePageLoader = () => {
  const context = useContext(PageLoaderContext)!;
  return context;
};

export const PageLoader = () => (
  <div
    className={`flex items-center justify-center fixed z-[9999] top-0 left-0 w-full h-full backdrop-blur-sm loader-backdrop`}
  >
    <LoaderAnimation />
  </div>
);
